import * as React from 'react';
import {History} from 'history';
import {TicketEvent} from '../../models/ticketEvent';
import {bind} from '../../decorators/bind';
import {BaseComponent} from '../baseComponent';
import {Translate} from '../../services/translate';
import {lazyInject} from '../../services/container';
import { Link } from 'react-router-dom';
import arrowIcon from '../../assets/images/icon_navbar_arrow_back.png';

interface TicketEventEntryProps
{
    history: History;
    event: TicketEvent;
}

export class TicketEventEntry extends BaseComponent<TicketEventEntryProps>
{
    @lazyInject(Translate)
    private translate: Translate;
    
    public render(): React.ReactNode
    {
        const event: TicketEvent = this.props.event;
        const link = this.translate.formatLink(`/esemenyek/${this.props.event.slug || this.props.event.id}`);
        
        return <Link className="ticket-entry ticket-event-entry" to={link}>
            <div>
                <div className="ticket-event-date">
                    <div className="ticket-event-month">{event.eventDate.toFormat('LLLL')}</div>
                    <div className="ticket-event-day">{event.eventDate.toFormat('dd')}</div>
                </div>
                <div className="ticket-event-name">
                    {event.name}
                </div>
            </div>
            <div>
                <div className="ticket-event-location">
                    {event.location}
                </div>
                <div className="ticket-large-text ticket-signup-text">
                    <span>{this.translate.translate('booking')}</span>
                    <img className="right-arrow-icon" src={arrowIcon} alt=""/>
                </div>
            </div>
        </Link>;
    }
}